module.exports = __webpack_public_path__ + "static/media/cat-final-test-bg.68fa0633.png";